import React from "react";
import {
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { CptAudit } from "../../types/cptAudit.types";
import { CptAuditTooltipContent } from "./CptAuditTooltipContent";

export interface DeliveryOptionCptAuditInfoProps {
  audit: CptAudit;
}

const containPopoverScroll = (event: React.WheelEvent<HTMLDivElement>) => {
  event.stopPropagation();

  const container = event.currentTarget;
  const { scrollTop, scrollHeight, clientHeight } = container;
  const canScroll = scrollHeight > clientHeight + 1;

  // Nothing to consume here; let the page/modal handle the wheel event.
  if (!canScroll) return;

  const scrollingUp = event.deltaY < 0;
  const scrollingDown = event.deltaY > 0;
  const atTop = scrollTop <= 0;
  const atBottom = scrollTop + clientHeight >= scrollHeight - 1;

  if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
    event.preventDefault();
  }
};

export const DeliveryOptionCptAuditInfo: React.FC<
  DeliveryOptionCptAuditInfoProps
> = ({ audit }) => (
  <Popover
    trigger="hover"
    placement="right"
    openDelay={200}
    isLazy
    gutter={10}
    flip
  >
    <PopoverTrigger>
      <IconButton
        variant="unstyled"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        minW="auto"
        h="auto"
        cursor="pointer"
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
        aria-label="View delivery time calculation details"
        icon={<InfoOutlineIcon color="blue.500" boxSize={3.5} />}
      />
    </PopoverTrigger>
    <Portal>
      <PopoverContent
        width="auto"
        borderColor="gray.200"
        boxShadow="md"
        zIndex={1600}
        maxH="70vh"
        overflow="hidden"
        overscrollBehavior="contain"
        onWheel={(event) => event.stopPropagation()}
        _focus={{ boxShadow: "md" }}
      >
        <PopoverBody
          px={3}
          py={1.5}
          maxH="70vh"
          overflowY="auto"
          overscrollBehavior="contain"
          onWheel={containPopoverScroll}
        >
          <CptAuditTooltipContent audit={audit} />
        </PopoverBody>
      </PopoverContent>
    </Portal>
  </Popover>
);
